import React from 'react'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Page from 'components/Page'
import Input from 'components/shared/Input'
import SensorInfo from 'components/Page/TankSearch/SensorInfo'
import DeviceInfo from 'components/Page/TankSearch/DeviceInfo'
import { getTankInfo, updateTankInfo, getMaterialCodes } from 'http/tank'
import { setLoader } from 'utils/loader'
import { transformTank } from 'utils/common'
import { Error, ITank } from 'types'
import * as utils from 'utils/common'
import EditMode from 'src/components/Page/TankSearch/SensorInfo/EditMode'

interface State {
  error: Error | string
  deviceId: string
  searched: boolean
  device: ITank
  originalDevice: ITank
  editMode: boolean
  editModeSensor: boolean
  mbSelectDate: string
  altSelectDate: string
  materialCodes: any
  quantity: any
  selectedMaterialCode: string
  pvalue: any,
  materialName: string
}

class TankSearch extends React.PureComponent<null, State> {
  state = {
    error: Error.NONE,
    deviceId: '',
    searched: false,
    device: null,
    originalDevice: null,
    editMode: false,
    editModeSensor: false,
    mbSelectDate: '',
    altSelectDate: '',
    materialCodes: null,
    quantity: 1,
    selectedMaterialCode: '',
    pvalue: null,
    materialName: ''
  }

  private turnOnEditMode = () => {
    this.setState(state => ({
      ...state,
      editMode: true,
      originalDevice: state.device,
    }))
  }

  private turnOnEditModeSensor = () => {
    var mbDt = new Date(this.state.device.mbDate);
    var altDt = new Date(this.state.device.altDate);
    var mbDateDb = utils.dateStringYYYYMMDD(mbDt);
    var altDateDb = utils.dateStringYYYYMMDD(altDt);
    this.setState(state => ({
      ...state,
      editModeSensor: true,
      originalDevice: state.device,
      mbSelectDate: mbDateDb,
      altSelectDate: altDateDb
    }))
  }

  private canSave = () => {
    const { device, originalDevice } = this.state
    if (!device || !originalDevice) return false
    let canSave = false
    const keys = Object.keys(device)
    for (let i = 0; i < keys.length; i++) {
      if (device[keys[i]] !== originalDevice[keys[i]]) {
        // device info has been changed
        canSave = true
        // if (typeof device[keys[i]] === 'string' && !device[keys[i]]) {
        //   // new info is empty, which is invalid
        //   return false
        // }
      }
    }
    return canSave
  }


  private saveDeviceChange = async () => {
    const { device, originalDevice } = this.state
    if (device.country == 'nz') {
      device.zone = 'Not Available';
    }
    // tushar code added (start)
    if (JSON.stringify(device.settings) === JSON.stringify(originalDevice.settings)) // true
    {
      console.log(true)
    }
    else {
      let reorder = device.settings;
      device.settings = originalDevice.settings;
      device.settings.reorder = reorder;
      console.log(false)
    }
    let error = Error.NONE
    setLoader(true)

    try {
      const { info, ...rest } = device
      const { messageCode, messageStatus } = await updateTankInfo(
        device.deviceID,
        rest
      )
      if (messageStatus === 'error') {
        error = messageCode
      }
    } catch (err) {
      error = err.message
    }
    this.setState(state => ({
      ...state,
      editMode: error !== Error.NONE ? true : false,
      editModeSensor: error !== Error.NONE ? true : false,
      originalDevice: error !== Error.NONE ? originalDevice : null,
      error,
    }))
    setLoader(false)
  }

  private cancelDeviceChange = () => {
    this.setState(state => ({
      ...state,
      editMode: false,
      error: Error.NONE,
      device: state.originalDevice,
      originalDevice: null,
    }))
  }

  private cancelSensorChange = () => {
    this.setState(state => ({
      ...state,
      editModeSensor: false,
      error: Error.NONE,
      device: state.originalDevice,
      originalDevice: null,
    }))
  }

  private handleDeviceIdChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({
      ...this.state,
      deviceId: evt.currentTarget.value,
    })
  }

  private handleInputChange = (prop: string) => (
    evt:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {

    if (prop == 'sh' && evt.target.value.length > 10) {
      return;
    }
    if (evt.target.name !== undefined && evt.target.name == 'manifoldCode') {
      var selectedMaterialCode, materialName, quantity, capacity, pvalue;
      if (prop === 'quantity') {
        if (Number(evt.target.value) === 0) {
          quantity = '';
        }
        else {
          quantity = Number(evt.target.value);
        }
      }
      else {
        quantity = (this.state.device.quantity !== undefined ? Number(this.state.device.quantity) : '');
      }

      if (prop === 'productcode') {
        selectedMaterialCode = evt.target.value;
      }
      else {
        selectedMaterialCode = this.state.device.productcode;
      }

      let objMaterialCodes = this.state.materialCodes.find(o => o.materialcode === selectedMaterialCode);
      capacity = objMaterialCodes.capacity * quantity;
      pvalue = objMaterialCodes.pressure;
      materialName = objMaterialCodes.materialname;
      this.setState({
        ...this.state,
        device: {
          ...this.state.device,
          [prop]: evt.target.value,
          capacity: capacity,
          quantity: quantity,
          pvalue: pvalue
        },
        materialName: materialName
      })
    }
    else {
      this.setState({
        ...this.state,
        device: {
          ...this.state.device,
          [prop]: evt.target.value
        }
      })
    }
  }

  private handleDateChange = (prop: string) => (
    evt: React.ChangeEvent<HTMLInputElement>
  ) => {

    let dt = new Date(evt.target.value);
    var mbDateVal = dt.getTime();
    if (prop == 'mbDate') {
      this.setState({
        ...this.state,
        device: {
          ...this.state.device,
          [prop]: mbDateVal,
        },
        mbSelectDate: evt.target.value
      })
    }
    else if (prop == 'altDate') {
      this.setState({
        ...this.state,
        device: {
          ...this.state.device,
          [prop]: mbDateVal,
        },
        altSelectDate: evt.target.value
      })
    }
  }

  private handleCheckboxChange = (prop: string) => (
    evt: React.ChangeEvent<HTMLInputElement>
  ) => this.setState({
    ...this.state,
    device: {
      ...this.state.device,
      [prop]: evt.target.checked
    }
  })

  private search = async event => {
    event.preventDefault()
    setLoader(true)
    let error = Error.NONE
    let device: ITank
    const { deviceId } = this.state
    var materialCodes, selectedMaterialCode, materialName;
    // var quantity = 1;
    // var pvalue;
    try {
      const { messageStatus, messageCode, data } = await getTankInfo(deviceId)
      if (messageStatus === 'error') {
        error = messageCode
      } else {
        device = Object.values(data)[0] as ITank
        device = transformTank(device)

        //if (device !== undefined && (device.type.toString().indexOf('manifold') !== -1 || device.type.toString().toUpperCase() === 'BLEREADER')) {
        var dataMaterialCode = await getMaterialCodes()
        materialCodes = dataMaterialCode.data.Items;

        if (device.productcode !== undefined) {
          let objMaterialCodes = materialCodes.find(o => o.materialcode === device.productcode);
          if (objMaterialCodes !== undefined) {
            materialName = objMaterialCodes.materialname;
            selectedMaterialCode = device.productcode;
            materialName = materialName;  //Material name to display
          }
          else {
            materialName = '';
            selectedMaterialCode = '';
          }
        }
        else {
          materialName = '';
          selectedMaterialCode = '';
        }
        //}
        if (!device) {
          error = Error.DEVICE_NOT_FOUND
          localStorage.removeItem('deviceID');

        }
        else {
          localStorage.removeItem('deviceID');
        }
      }
    } catch (err) {
      console.log(err)
      error = err.message
    }
    this.setState(state => ({
      ...state,
      searched: true,
      error,
      device,
      materialCodes,
      selectedMaterialCode,
      materialName
    }))
    setLoader(false)
  }
  componentDidMount() {
    var deviecIdFromTank = localStorage.getItem('deviceID');
    this.setState({
      ...this.state,
      deviceId: deviecIdFromTank
    });

  }
  render() {

    const { searched, device, error, editMode, editModeSensor, mbSelectDate, altSelectDate, materialCodes, materialName } = this.state
    return (
      <Page title="Search">
        <Grid container direction="column">
          <Grid item>
            <form name="search" onSubmit={this.search}>
              <Grid container direction="column" item>
                <Grid item>
                  <Input label="Device ID" value={this.state.deviceId} onChange={this.handleDeviceIdChange} />
                </Grid>
                <Grid item>
                  <Box mt={{ xs: 1, md: 3 }} mb={{ xs: 3, md: 4, lg: 6 }}>
                    <Button fullWidth variant="contained" type="submit" disabled={!this.state.deviceId}>
                      <Typography variant="h4" color="primary">
                        Search
                      </Typography>
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </form>
          </Grid>
          {searched && (
            <Grid item>
              {error !== Error.NONE && (
                <Box mb={2}>
                  <Typography variant="h4" color="error">
                    {error}
                  </Typography>
                </Box>
              )}
              {device && (
                <Grid container justify="space-around">
                  <Grid container direction="column" item xs={12} sm={5}>
                    <Box p={{ xs: 4 }} mb={{ xs: 2, sm: 0 }} style={{ backgroundColor: '#fff' }}>
                      <Grid item>

                      </Grid>
                      <Grid item>
                        <DeviceInfo
                          canSave={this.canSave()}
                          device={device}
                          materialCodes={materialCodes}
                          materialName={materialName}
                          editMode={editMode}
                          editModeSensor={editModeSensor}
                          onEdit={this.turnOnEditMode}
                          onCancel={this.cancelDeviceChange}
                          onSave={this.saveDeviceChange}
                          onInputChange={this.handleInputChange}
                          onCheckboxChange={this.handleCheckboxChange}
                        />
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <Box p={{ xs: 4 }} style={{ backgroundColor: '#eee' }}>
                      <SensorInfo
                        canSave={this.canSave()}
                        device={device}
                        editMode={editMode}
                        editModeSensor={editModeSensor}
                        onEditSensor={this.turnOnEditModeSensor}
                        onCancel={this.cancelSensorChange}
                        onSave={this.saveDeviceChange}
                        onInputChange={this.handleInputChange}
                        onDateChange={this.handleDateChange}
                        mbSelectDate={mbSelectDate}
                        altSelectDate={altSelectDate}
                      />
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </Page>
    )
  }
}

export default TankSearch
